// ----------------------------------------------------------------------

export default function DataTable() {
    return {
        MUIDataTableBodyCell: {
            styleOverrides: {
                root: {
                    textAlign: "center"
                }
            }
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    textAlign: "center"
                },
                contentWrapper: {
                    justifyContent: "center"
                }
            }
        }

    };
}
